import React from 'react';
import { ClockIcon, ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
export function UrgencyTimeline() {
  const milestones = [{
    month: 1,
    status: 'Nog steeds kwetsbaar',
    color: 'bg-red-500'
  }, {
    month: 3,
    status: 'Risico op infecties',
    color: 'bg-orange-500'
  }, {
    month: 6,
    status: 'Immuunsysteem nog zwak',
    color: 'bg-yellow-500'
  }, {
    month: 9,
    status: 'Eindelijk herstel?',
    color: 'bg-green-500'
  }];
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-red-50 to-white" data-id="element-346">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-347">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[rgb(var(--color-neutral-900))] mb-4 sm:mb-6" data-id="element-348">
          Waarom Wachten Geen Optie Is
        </h2>

        <p className="text-lg sm:text-xl text-center text-[rgb(var(--color-neutral-800))] mb-8 sm:mb-12 max-w-3xl mx-auto" data-id="element-349">
          De Lange Weg naar Herstel
        </p>

        <div className="bg-white p-6 sm:p-8 lg:p-12 rounded-2xl shadow-xl mb-6 sm:mb-8" data-id="element-350">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6 sm:mb-8" data-id="element-351">
            <ClockIcon className="w-12 h-12 sm:w-16 sm:h-16 text-[rgb(var(--color-danger))]" data-id="element-352" />
            <div className="text-center sm:text-left" data-id="element-353">
              <p className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[rgb(var(--color-danger))]" data-id="element-354">
                6-9
              </p>
              <p className="text-lg sm:text-xl font-semibold text-[rgb(var(--color-neutral-800))]" data-id="element-355">
                maanden herstel
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-356">
            {/* Desktop: Horizontal timeline */}
            {/* Mobile: Vertical timeline */}

            {/* Horizontal line for desktop */}
            <div className="hidden lg:block absolute top-8 left-0 right-0 h-2 bg-gradient-to-r from-red-500 via-yellow-500 to-green-500 rounded-full" data-id="element-357"></div>

            {/* Vertical line for mobile */}
            <div className="lg:hidden absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-red-500 via-yellow-500 to-green-500 rounded-full" data-id="element-358"></div>

            {/* Milestones */}
            <div className="flex flex-col lg:grid lg:grid-cols-4 gap-6 lg:gap-6 relative" data-id="element-359">
              {milestones.map((milestone, index) => <div key={index} className="relative flex lg:block items-start lg:items-center" data-id="element-360">
                  {/* Mobile: horizontal layout with marker on left */}
                  <div className="lg:hidden flex items-center gap-4 w-full" data-id="element-361">
                    <div className={`${milestone.color} w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg flex-shrink-0 z-10`} data-id="element-362">
                      {milestone.month}
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg flex-1" data-id="element-363">
                      <p className="font-semibold text-[rgb(var(--color-neutral-900))] mb-1" data-id="element-364">
                        Maand {milestone.month}
                      </p>
                      <p className="text-sm text-[rgb(var(--color-neutral-800))]" data-id="element-365">
                        {milestone.status}
                      </p>
                    </div>
                  </div>

                  {/* Desktop: vertical layout */}
                  <div className="hidden lg:block" data-id="element-366">
                    <div className={`${milestone.color} w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center text-white font-bold text-xl shadow-lg relative z-10`} data-id="element-367">
                      {milestone.month}
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg text-center" data-id="element-368">
                      <p className="font-semibold text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-369">
                        Maand {milestone.month}
                      </p>
                      <p className="text-sm text-[rgb(var(--color-neutral-800))]" data-id="element-370">
                        {milestone.status}
                      </p>
                    </div>
                  </div>

                  {/* Arrow for desktop only */}
                  {index < milestones.length - 1 && <ArrowRightIcon className="hidden lg:block absolute top-6 -right-8 w-8 h-8 text-gray-400" data-id="element-371" />}

                  {/* Arrow for mobile only */}
                  {index < milestones.length - 1 && <ArrowDownIcon className="lg:hidden absolute left-6 -bottom-3 w-6 h-6 text-gray-400 z-0" data-id="element-372" />}
                </div>)}
            </div>
          </div>

          <div className="mt-6 sm:mt-8 text-center" data-id="element-373">
            <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] italic leading-relaxed" data-id="element-374">
              Zonder ondersteuning kan het herstel van een beschadigde darmflora
              tot wel 6 tot 9 maanden duren! Gedurende deze periode blijft je
              hond kwetsbaar voor allerlei klachten.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white p-6 sm:p-8 rounded-2xl text-center shadow-xl" data-id="element-375">
          <p className="text-xl sm:text-2xl font-bold mb-2" data-id="element-376">
            Maar het kan sneller!
          </p>
          <p className="text-base sm:text-lg mb-4" data-id="element-377">
            Ontdek hoe je de darmgezondheid van je hond kunt versnellen
          </p>
          <div className="animate-bounce" data-id="element-378">
            <span className="text-3xl sm:text-4xl" data-id="element-379">↓</span>
          </div>
        </div>
      </div>
    </section>;
}